<template>
  <v-container fluid>
    <ModalRecurso
      :modalRecurso="modalRecurso"
      :editRecurso="editRecursoObj"
      @close="closeModalRecurso"
    />
    <Grid
      title="Recursos"
      :headers="headers"
      :items="recursos"
      @novo="modalRecurso = true"
      @edit="editRecurso"
      @destroy="destroyRecurso"
      @atualiza="getRecursos"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';
import ModalRecurso from '@/components/recurso/ModalRecurso';

export default {
  name: 'Recursos',
  data: () => ({
    modalRecurso: false,
    editRecursoObj: null,
    headers: [
      {
        text: 'Descrição',
        align: 'start',
        value: 'descricao',
      },
      { text: 'Recurso', value: 'recurso' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
    ModalRecurso
  },
  computed: {
    ...mapGetters(['recursos'])
  },
  methods: {
    ...mapActions(['fetchRecursos', 'deleteRecurso']),
    closeModalRecurso() {
      this.editRecursoObj = null;
      this.modalRecurso = false;
    },
    getRecursos() {
      this.fetchRecursos({ limit: 999 });
    },
    editRecurso(recurso) {
      this.editRecursoObj = { ...recurso };
      this.modalRecurso = true;
    },
    destroyRecurso(recurso) {
      if (confirm(`Tem certeza que deseja excluir o recurso: ${recurso.componente}?`)) {
        this.deleteRecurso(recurso._id);
      }
    }
  },
  created() {
    this.getRecursos();
  }
}
</script>

<style>

</style>